export const Constants = {
  appTitle: 'DCODE',

  content: 'Content',
  diagnosticSpecificatiosn: 'Diagnostic Specifications',
  diagnosticFamilies: 'Diagnostic Families',
  identificationGroups: 'Identification Groups',
  sharedFiles: 'Shared Files',
  vsoc: 'Vsoc',

  export: 'Export',
  packages: 'Packages',
  label: 'Label',

  rbacc: 'Rbacc',
  rbaccHeading: 'Rbacc Files',
  rbaccSubHeading: 'Rbacc is Role based access control. You can upload Rbacc file here to filter the request to executed to ECU by user roles.',
  rbaccEditorHeading: 'Rbacc Editor',
  rbaccEditorSubHeading: 'Create and review RBACCs.',
  wikiUrl: 'https://scaniaazureservices.sharepoint.com/sites/GadgetHelpdesk/_layouts/15/Doc.aspx?sourcedoc={dcf7c597-724e-4609-b219-9a9d2cec0ae6}&action=edit&wd=target%28DCode.one%7C2e949af4-9e9b-4f6c-b692-3dfc6bbf091e%2FNew%20RBACC%7C692aa34f-1358-4a90-80a4-62d8f89b277f%2F%29&wdorigin=703',
  protocol: 'Protocol',
  generations: 'Generations',
  noLogsMsg: 'No change logs available.',
  labelHeading: 'Export Label',
  logout: 'Logout',

  specifications: 'Specifications',
  specificationslabel: 'Specifications Label',
  selectedGeneration: 'Selected Generation',
  secUpdateDiagnoVersion : 'Secure Update Diagnostic Version',

  newBuildLabelText: 'Add new build',
  newLabelDescription: 'When creating a build label, all new specifications/specification versions that have both the Main label and are marked for Release will get this label.A build label within DCODE will not affect the build label for the production SCOMMDb build.',
  notFound: 'No data found/available',
  specificationVersionTab: 'Specification Versions',
  serverIdentificationTab: 'Server Identifications',
  identificationGroup: ' Identification groups order can be changed from the',
  listView: 'list',
  cardView: 'card',
  identification: 'Identification',
  expression: 'Expression',
  specification: 'Specification',
  version: 'Version', 
  confirmDelete: 'Confirm Deletion',
  subheading: 'Select a yaml file to upload:',
  confirmDeleteMessage: 'Are you sure you want to delete this item?',
  heading: 'Manage Yaml',
  subheadingYaml: 'Select a yaml file to upload:',
  validFileMessage: 'There are no errors in this Rbacc File.File is validated',
  confirmProceedMessage: 'Are you sure you want to proceed with this action?',
  confirmTitle: 'Confirm Deletion',
  confirmMessage: 'Are you sure you want to delete this item?',
  includeSecurityAccessLabel: 'Include security access keys',

  updateOdxFile:'Update Odx File',
  odxPreview:'Odx Preview',
  odxPreviewSubheading:'Diagnostic services in Dcode with the latest definitions from an ODX file.The following changes will be applied to the current diagnostic specification version. Use the options in the "Action" column if you would like to skip certain updates from being applied',
  
  newSecureUpdaeDiagVersoinLabelText: 'Add new Secure Update Diagnostic Version',
  newSecureUpdaeDiagVersoinDescription: 'When creating a new Secure Update Diagnostic Version, should be provided Platform and Version number',
  connectSecDiagVersionToSpecification:'Connect Version to Specification',
  connectSecDiagVersionToSpecificationDescription:'Connect this New Version to existing Specification(s)',
  noConnectedSpecificationFound:'No connected Specification',
  packageSubHeading: 'Select specification versions to create a local release for testing. You can base your export on a label. If needed, you can exchange specifications with other versions.',
  NO_LABEL_TEXT: 'No Label',

};

export const Roles = {
  ADMIN: "Admin",
  SYSTEMOWNER: "System Owner",
  READER: "Reader",
  COLLABORATOR: "Collaborator",
  ADVANCED: "Advanced"
}

export const RolePriority: { [key: string]: number } = {
  'basic': 1,
  'reader': 1,
  'AP3698001-dcode-prod-basic': 1,
  'AP3698001-CN-Reader': 1,

  'extended': 2,
  'collaborator': 2,
  'AP3698001-dcode-prod-extended': 2,

  'complete': 3,
  'system-owner': 3,
  'AP3698001-dcode-prod-complete': 3,
  'AP3698001-CN-SystemOwner': 3,

  'advanced': 4,
  'rbacc-approver': 4,
  'AP3698001-dcode-prod-advanced': 4,

  'admin': 5,
  'AP3698001-dcode-prod-admin': 5,
};

export const RoleMappings: { [key: string]: string } = {
  'admin': 'Admin',
  'AP3698001-dcode-prod-admin': 'Admin',

  'advanced': 'Advanced',
  'rbacc-approver': 'Advanced',
  'AP3698001-dcode-prod-advanced': 'Advanced',

  'complete': 'System Owner',
  'system-owner': 'System Owner',
  'AP3698001-dcode-prod-complete': 'System Owner',
  'AP3698001-CN-SystemOwner': 'System Owner',

  'extended': 'Collaborator',
  'collaborator': 'Collaborator',
  'AP3698001-dcode-prod-extended': 'Collaborator',

  'basic': 'Reader',
  'reader': 'Reader',
  'AP3698001-dcode-prod-basic': 'Reader',
  'AP3698001-CN-Reader': 'Reader',
};

export enum SesammVersion {
  Six,
  Seven
}
